__turbopack_context__.v({
  "closeButton": "exN1ha_closeButton",
  "fadeOut": "exN1ha_fadeOut",
  "heading": "exN1ha_heading",
  "links": "exN1ha_links",
  "menu": "exN1ha_menu",
  "menuText": "exN1ha_menuText",
  "scrollbar": "exN1ha_scrollbar",
});
